/* unplugin-vue-components disabled */import script from "./TtgBJ.vue?vue&type=script&setup=true&lang=js"
export * from "./TtgBJ.vue?vue&type=script&setup=true&lang=js"

import "./TtgBJ.vue?vue&type=style&index=0&id=04f0932e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04f0932e"]])

export default __exports__